export default __webpack_public_path__ + "header-image-960-f85d3cef51256a70983e08cdadf545bf.png";